const KEY_ACCEPTED = 'cookie-accepted';

export default {
    actions: {
        apply: function (ctx, data) {
            if (!!localStorage.getItem('access_token')) {
                axios.put(this._vm.$path + '/updateUserInfo', {cookies: data}, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('access_token')
                    }
                }).then(response => {
                }).catch(err => {
                    console.error(err.response);
                });
            }

            ctx.commit('enableAccepted', 'yes');
        }
    },
    mutations: {
        enableAccepted: function (state, value) {
            state.accepted = value;
            localStorage.setItem(KEY_ACCEPTED, value);
        }
    },
    state: {
        accepted: !!localStorage.getItem(KEY_ACCEPTED)
    },
    getters: {}
}
